export default __webpack_public_path__ + "static/media/Clearance Form.6f882090.pdf";